import axios from 'axios';
import store from '../store/index.js'
import { Buffer } from 'buffer';

// token 3e6b57ef6225913:296bfacff07ddfb is conveted to base64 as MGNlZDkzNTc3ZWY2MjI1OTEzOjI5NmJmYWNmZjA3ZGRmYg==
// which is used in the Authorization header as:
// Authorization: Basic MGNlZDkzNTc3ZWY2MjI1OTEzOjI5NmJmYWNmZjA3ZGRmYg==
// which is how frappe expects the token to be sent in the header
// or Authorization: Token 3e6b57ef6225913:296bfacff07ddfb

// Which credential this screen may use right now:
//   'session' - a desk session cookie exists; authenticate with it, plus the CSRF token when the
//               session carries one (frappe skips the CSRF check when it does not).
//   'token'   - nobody is logged in; authenticate with the API key/secret from Settings > Token.
// Exactly one of the two, never both: an API key sent alongside a session cookie wipes that
// session server-side (frappe.set_user clears session.data, which after_request writes back).
let auth_mode = 'token'
let csrf_token = null

const API = axios.create()

API.interceptors.request.use(config => {
  delete config.headers['Authorization']
  delete config.headers['X-Frappe-CSRF-Token']
  if (auth_mode === 'session') {
    if (csrf_token) config.headers['X-Frappe-CSRF-Token'] = csrf_token
  } else {
    const token = store.state?.settings?.token
    // an Authorization header that is not a real key:secret makes frappe reject the whole
    // request (InvalidAuthorizationToken), so send none at all when no token is configured
    if (token) config.headers['Authorization'] = `Basic ${Buffer.from(token).toString('base64')}`
  }
  return config
})

// Called at boot and re-run periodically, so a screen whose session expires mid-shift falls back
// to the API key on its own instead of going silently unauthenticated until someone reloads it.
// 403 here means Guest; 200 means a live session (with or without a CSRF token).
const setup_api = function() {
  return fetch('api/method/misc.misc.login_helper.get_csrf_token')
  .then(response => response.ok
    ? response.json().then(data => ({ mode: 'session', csrf: data.message || null }))
    : { mode: 'token', csrf: null })
  .catch(ex => {
    console.log(ex)
    return { mode: 'token', csrf: null }
  })
  .then(result => {
    auth_mode = result.mode
    csrf_token = result.csrf
  })
}


export {
  API,
  setup_api
}
